const TEMPLATE_HEADERS = [
  'Year',
  'HIOS Plan ID',
  'State',
  'Benefit',
  'Service Not Covered',
  'Applies To Deductible',
  'Coinsurance',
  'Copay Amount',
  'Copay Day Limit',
  'Coinsurance Copay Order',
  'Member Service Paid Cap',
  'Coverage Visit Limit',
  'First Dollar Visits',
  'Is Grouped',
  'Copay After First Visits',
  'Notes',
  'Benefit Display Value',
]

export function downloadPlanBenefitTemplate(): void {
  const csv = TEMPLATE_HEADERS.join(',')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'plan-benefit-template.csv'
  link.click()
  URL.revokeObjectURL(url)
}
